export default class FilterTable {
    constructor(el) {
        this.el = el;
        this.colWidth = [];
        this.init();
    }

    init() {
        this.filters = this.el.getAttribute("data-filters").split(",");
        this.filter = this.el.querySelector("#filter");

        this.table = this.el.querySelector("table");
        let cols = this.table.querySelector("tr:has(td)").querySelectorAll("td");

        for (let i = 0; i < cols.length; i++) {
            const col = cols[i];
            let colInFirstRow = this.table.querySelectorAll("tr:first-child>*")[i];
            colInFirstRow.style.width = col.offsetWidth + "px";
        }

        // cols.forEach(col => {
        //     this.colWidth.push(col.offsetWidth);
        // });

        this.makeTableSmart();
    }

    makeTableSmart() {
        const headers = this.table.querySelectorAll('tr:first-child>td,th');
        const selectedValues = {};
    
        headers.forEach((header, index) => {
            if (this.filters.includes(header.textContent)) {
                const columnValues = Array.from(this.table.querySelectorAll(`td:nth-child(${index + 1})`))
                    .map(td => td.textContent)
                    .filter((value, i, self) => self.indexOf(value) === i);
    
                const select = document.createElement('select');
                const defaultOption = document.createElement('option');
                defaultOption.text = `${header.textContent}`; // Placeholder for unfiltering
                defaultOption.value = ''; // Set an empty value for the placeholder
                defaultOption.selected = true;
                select.classList.add('default');
                select.add(defaultOption);
    
                columnValues.forEach(value => {
                    const option = document.createElement('option');
                    option.value = value;
                    option.text = value;
                    select.add(option);
                });
    
                select.addEventListener('change', () => {
                    selectedValues[header.textContent] = select.value || undefined; // Store undefined to unfilter
    
                    // Add 'default' class to the select when the default option is selected
                    if (select.selectedIndex === 0) {
                        select.classList.add('default');
                    } else {
                        select.classList.remove('default');
                    }
    
                    this.filterTable(selectedValues);
                });
    
                select.classList.add('c-input__field');
                select.classList.add('c-toggle-label');
    
                const container = document.createElement('div');
                container.className = 'c-input filter-container';
                container.appendChild(select);
                this.filter.appendChild(container);
            }
        });
    }

    filterTable(selectedValues) {
        const rows = this.table.querySelectorAll('tbody tr:not(:first-child)');
        let foundItems = false;
    
        rows.forEach(row => {
            let shouldDisplay = true;
    
            this.filters.forEach(filter => {
                const columnIndex = Array.from(this.table.querySelectorAll(`tr:first-child>td,th`))
                    .findIndex(th => th.textContent === filter);
                if (columnIndex !== -1) {
                    const cellValue = row.querySelectorAll('td')[columnIndex]?.textContent;
                    if (selectedValues[filter] !== undefined && selectedValues[filter] !== cellValue) {
                        shouldDisplay = false;
                    }
                }
            });
            
            if (shouldDisplay) {
                foundItems = true;
                row.style.display = ''; // Display the matching rows
            } else {
                row.style.display = 'none'; // Hide non-matching rows
            }
        });
    
        // If no matching items are found, display a row with "No items found"
        if (!foundItems) {
            const tbody = this.table.querySelector('tbody');
            const noItemsRow = document.createElement('tr');
            const cell = document.createElement('td');
            cell.setAttribute('colspan', tbody.querySelectorAll("tr:first-child>*").length.toString());
            cell.textContent = 'No items found';
            noItemsRow.appendChild(cell);
            noItemsRow.className = 'no-items-found';
            tbody.appendChild(noItemsRow);
        } else {
            // Remove the "No items found" row if previously added
            const noItemsRow = this.table.querySelector('tbody tr.no-items-found');
            if (noItemsRow) {
                noItemsRow.remove();
            }
        }
    }
    
}
